<script setup>
import { isMobile } from '../../utils/breakpoints';
import Flag from '../Flag/Flag.vue';
import { groupCollectionBy } from '../../utils/group';
import { sortCollectionAccordingDOWNLOADMATRIX_LANGUAGES } from '../../utils/sort';
import { onBeforeMount, ref } from 'vue';
import Button1XP from '../Button1XP/Button1XP.vue';

const props = defineProps({
  types: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
  },
  subTitle: {
    type: String,
    default: '',
  },
  section: {
    type: String,
  },
  countries: {
    type: Array,
    default: () => [],
  },
  labels: {
    type: Object,
    default: () => {},
  },
  context: {
    type: String,
  },
  wtParams: {
    type: Object,
  },
  hideTooltip: {
    type: Boolean,
    default: false,
  },
});

const groupedDownloadsByUrlRef = ref({});

const isMobileDevice = isMobile;
const wtTrack = window.wtTrack;

const countriesRef = ref([...props.countries]);

const sortCountries = () => {
  const buffer = sortCollectionAccordingDOWNLOADMATRIX_LANGUAGES(
    countriesRef.value,
    'language',
    'asc',
  );
  const idxCurrentLanguage = buffer.findIndex(
    (elem) => elem.language && elem.language.toUpperCase() === window.currentLanguage,
  );

  // Set current language at the beginning of the array
  if (idxCurrentLanguage > -1) {
    buffer.splice(0, 0, buffer.splice(idxCurrentLanguage, 1)[0]);
  }

  countriesRef.value = buffer;
};

const groupDownloadsByUrl = () => {
  groupedDownloadsByUrlRef.value = groupCollectionBy(countriesRef.value, 'url');
};

onBeforeMount(() => {
  sortCountries();
  groupDownloadsByUrl();
});
</script>

<template>
  <ul :class="[$style.container, $style[context]]">
    <li v-for="(country, index) in countriesRef" :key="`${index}-${country.flag}`">
      <tippy
        v-tippy="{
          arrow: true,
          distance: 7,
          interactive: true,
          theme: '1xp light tooltip',
          zIndex: 10002,
          trigger: isMobileDevice ? 'click' : 'mouseenter focus',
        }"
      >
        <a
          :class="$style.flagContainer"
          :href="country.url || '#'"
          target="_blank"
          @click="
            wtParams &&
            wtTrack(
              { cat: wtParams.doctype },
              {
                ...wtParams,
                description:
                  country.wtParams && country.wtParams.description
                    ? country.wtParams.description
                    : wtParams.description || country.title || title,
                filename: country.url,
              },
            )
          "
        >
          <Flag :class="$style.flag" :flag="country.flag" size="s" :title="country.language" />
        </a>

        <template v-if="!hideTooltip" #content>
          <ul :class="$style.downloadLinks">
            <li v-if="country.ebook">
              <Button1XP
                start-icon="docs"
                target="blank"
                :text="labels.ebook"
                :url="country.ebook"
                variant="linkStatic"
                @click="
                  wtParams &&
                  wtTrack(
                    { cat: 'E_BOOK' },
                    {
                      ...wtParams,
                      doctype: 'E_BOOK',
                      description:
                        country.wtParams && country.wtParams.description
                          ? country.wtParams.description
                          : wtParams.description || country.title || title,
                      filename: country.ebook,
                    },
                  )
                "
              />
            </li>
            <li v-if="country.url">
              <Button1XP
                start-icon="picture_as_pdf"
                target="blank"
                :text="labels.pdf"
                :url="country.url"
                variant="linkStatic"
                @click="
                  wtParams &&
                  wtTrack(
                    { cat: wtParams.doctype },
                    {
                      ...wtParams,
                      description:
                        country.wtParams && country.wtParams.description
                          ? country.wtParams.description
                          : wtParams.description || country.title || title,
                      filename: country.url,
                    },
                  )
                "
              />
            </li>
          </ul>
        </template>
      </tippy>
    </li>
  </ul>
</template>

<style module lang="scss">
@forward './CountryDownloadBox.scss';
</style>
